import angular from 'angular'
import './style.scss'

document.write(require('./view.html').default);

angular.module("core.application.main").directive("core.application.main.directive.order", ["$rootScope", function($rootScope) {

    // PAYL-5171
    // This is an improved 'sort' directive which supercedes the old one
    // The old sort directive duplicated many aspects of the 'query' directive to keep it's state up to date
    // This new order directive just uses the 'query' directive instead to accomplish the same objective

    var expose = {};

    expose.restrict = "A";
    expose.templateUrl = "order.html";
    expose.transclude = true;
    expose.scope = {
        order: "=",
        orderBy: "="
    };

    expose.link = function($scope, element) {

        element.addClass("orderable");

        element.on("click", function() {
            $scope.$apply(function() {
                // change the current order orderBy column to this column
                // and the order direction to be in the opposite direction to what it was
                // it's expected that the parameters will be manually kept in sync with whatever queryParameters is set to in the calling code
                $scope.order.queryParameters.orderBy = $scope.orderBy;
                $scope.order.queryParameters.ascending = ! $scope.order.parameters.ascending;
                $rootScope.$broadcast("orderableSortChanged", {
                    orderBy: $scope.order.queryParameters.orderBy,
                    ascending: $scope.order.queryParameters.ascending
                });
            });
        });

        $scope.$watch("order", function(order) {
            // 'ascending' can be a string of 'true' or 'false' if it's read from the query parameters
            // we need to convert it to a proper boolean to make it consistent to work with in the code
            if (order && order.parameters) {
                if (order.parameters.ascending === "true") {
                    order.parameters.ascending = true;
                } else if (order.parameters.ascending === "false") {
                    order.parameters.ascending = false;
                }
            }
        }, true);

    };

    return expose;

}]);
